<template>
    <i18n
        keypath="enquiry.privacy_consent_label"
        tag="p"
        class="consent-notice"
    >
        <template #termsOfUse>
            <ThLink
                :to="routes.page('terms')"
                target="_blank"
            >
                {{ t('enquiry.terms_of_use') }}
            </ThLink>
        </template>

        <template #privacyPolicy>
            <ThLink
                :to="routes.page('privacy')"
                target="_blank"
            >
                {{ t('enquiry.privacy_policy') }}
            </ThLink>
        </template>

        <template #cookiePolicy>
            <ThLink
                :to="routes.page('cookies')"
                target="_blank"
            >
                {{ t('enquiry.cookie_policy') }}
            </ThLink>
        </template>
    </i18n>
</template>

<script setup lang="ts">
import { useRoutes } from '@/router/routes'
import { useI18n } from 'vue-i18n'

import ThLink from '../ui/buttons/ThLink.vue'

const routes = useRoutes()
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.consent-notice {
    font-family: $sectra-font-stack;
    font-style: normal;
    font-weight: 400;
    color: $slate;
    font-size: 0.75rem;
    line-height: 1.4em;
    cursor: default;
    padding: 0 10px;

    a {
        color: $blue;
        cursor: pointer;
    }
}
</style>
